

























































































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import { gudindanweishuzi, kebiandanweishuzi } from "./ziduans";
import Hover from "./hover.vue";
@Component({
  components: {
    Hover
  }
})
export default class ProjectThirdControlShuzhiti extends Vue {
  @Prop()
  private ziduan: any;
  @Prop()
  private index: any;
  private defaultValue: any = "";
  private defaultValue2: any = "";
  private ifShowConfig: boolean = false;
  private temp: any = {
    content: {
      options: [],
      unit: ""
    }
  };
  /**
   * @description 打开配置弹窗
   */
  private openConfigDialg() {
    this.temp = _.cloneDeep(this.ziduan);
    this.ifShowConfig = true;
  }
  /**
   * @description 切换成固定单位数字
   */
  private toggleGuding() {
    this.$set(this.temp.content, "id", gudindanweishuzi.id);
    this.$set(this.temp.content, "type", gudindanweishuzi.type);
    this.$set(this.temp.content, "unit", gudindanweishuzi.unit);
    this.$set(this.temp.content, "value", gudindanweishuzi.value);
    delete this.temp.content.options;
  }
  private toggleKebian(length) {
    this.$set(this.temp.content, "id", kebiandanweishuzi.id);
    this.$set(this.temp.content, "type", kebiandanweishuzi.type);
    this.$set(this.temp.content, "unit", "");
    this.$set(this.temp.content, "options", []);
    this.temp.content.options.length = length;
    for (let i = 0; i < this.temp.content.options.length; i++) {
      this.temp.content.options[i] = "单位" + (i + 1);
    }
    this.$set(this.temp.content, "value", kebiandanweishuzi.value);
  }
  /**
   * @description 固定单位输入
   */
  private gudingInputChange(val) {
    this.temp.content.unit = val;
  }
  /**
   * @description 可变单位输入
   */
  private kebianInputChange(val, index) {
    this.temp.content.options[index] = val;
    this.$forceUpdate();
  }
  /**
   * @description 保存
   */
  private save() {
    // 检查标题
    if (!this.temp.content.title) {
      this.$message.warning("标题不能为空");
      return;
    }

    if (this.temp.content.type === "可变单位数字") {
      if (this.temp.content.options.length <= 0) {
        this.$message.warning("请至少填写一个可选单位");
        return;
      } else {
        const obj = {};
        for (const i in this.temp.content.options) {
          if (i) {
            if (obj[this.temp.content.options[i]]) {
              this.$message.warning(
                "第" + (i + 1) + "个单位有重复，请重新填写"
              );
              return;
            }
            obj[this.temp.content.options[i]] = true;
          }
        }
        this.defaultValue2 = this.temp.content.options[0];
        this.$forceUpdate();
      }
    }
    this.$emit("ziduanChange", this.temp);
    this.ifShowConfig = false;
  }
  /**
   * @description 取消/关闭弹窗
   */
  private closeDialog() {
    this.temp = {};
    this.ifShowConfig = false;
  }
  /**
   * @description 删除这个字段
   */
  private deleteThis() {
    this.$emit("del");
  }
}
